
import moment from "moment";
import { filterObj } from "ui-lib";
import javaTimeFormat from "../java-time-format";
import fetchApi from "../fetch-api";
import { getQueryPath } from "../get-query-path";
import { CompaniesIO } from "../company-io";
import PaginatedResponseIO from "../api";

type Query = {
  industry?: string;
  latestRegistered?: boolean;
  pageSize?: number;
  page?: number;
  from?: string;
  to?: string;
};

export const CompanySearchResultIO = PaginatedResponseIO(CompaniesIO);

export const DEFAULT_PAGE_SIZE = 30;

export const normalizeDate = (inputDate?: string) => {
  if (!inputDate) return inputDate;
  return moment
    .parseZone(inputDate, javaTimeFormat)
    .utc()
    .format(javaTimeFormat);
};

export const calculateToDate = (from?: string, to?: string) => {
  if (to) {
    return to;
  } else if (from) {
    return moment().add(1, "year").startOf("day").format(javaTimeFormat);
  }
  return undefined;
};

export const getCompanies = ({ from, to, pageSize, ...query }: Query) => {
  const fromFormatted = normalizeDate(from);
  const toFormatted = normalizeDate(calculateToDate(from, to));
  const filteredObj = filterObj(
    {
      limit: pageSize && pageSize,
      ...query,
      from: fromFormatted,
      to: toFormatted,
    },
    (_, value: any) => value !== undefined
  );
  const queryPath = getQueryPath({ ...filteredObj });

  return {
    queryKey: ["COMPANY_DETAIL", queryPath],
    queryFn: () =>
      fetchApi({
        service: "core-service",
        headers: { method: "GET" },
        pathname: `/companies?${queryPath}`,
        codec: CompanySearchResultIO,
      }),
  };
};
